import clsx from 'clsx'

import type { HTMLAttributes } from 'react'

interface StickyBarProps extends HTMLAttributes<HTMLDivElement> {}

const StickyFooter = ({ className, children }: StickyBarProps) => {
  return (
    <div
      className={clsx(
        className,
        'px-8 py-4 flex gap-5 justify-end fixed left-0 bottom-0 w-full bg-white z-[1]'
      )}
      style={{ boxShadow: '0px -2px 18px 0px rgba(114, 114, 114, 0.20)' }}
    >
      {children}
    </div>
  )
}

export default StickyFooter
